import { render, staticRenderFns } from "./taskquery.vue?vue&type=template&id=05241b46&scoped=true&"
import script from "./taskquery.vue?vue&type=script&lang=js&"
export * from "./taskquery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05241b46",
  null
  
)

export default component.exports